/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Department } from '../../models/department';
import { DepartmentApiRespModel } from '../../models/department-api-resp-model';

export interface ApiMasterDepartmentAddPost$Params {
      body?: Department
}

export function apiMasterDepartmentAddPost(http: HttpClient, rootUrl: string, params?: ApiMasterDepartmentAddPost$Params, context?: HttpContext): Observable<StrictHttpResponse<DepartmentApiRespModel>> {
  const rb = new RequestBuilder(rootUrl, apiMasterDepartmentAddPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DepartmentApiRespModel>;
    })
  );
}

apiMasterDepartmentAddPost.PATH = '/api/Master/Department/Add';
